export const environment = {
  production: true,
  baseUrl: 'https://api.sparo.stg01.hxa.io',
  appVersion: require('../../package.json').version + '-stage-az',
  unleash: {
    enabled: true,
    url: 'https://ftx.hxa.io/api/frontend/',
    clientKey:
      'default:development.786f0ee8d0f95b39d21f7e139eadea8ec126172dbcdd8454c2d2a3b7',
    appName: 'hxa-sparo-stg01',
  },
};
